import { DistributorLocation } from "../_models/DistributorLocation";
import { DistributorDeviceMapper } from "./DistributorDeviceMapper";
import { LicenseMapper } from "./LicenseMapper";

export class DistributorLocationMapper {
    static allServerToLocal(serverLocations = []) {
        return serverLocations.map(this.serverToLocal);
    }

    static serverToLocal(serverLocation) {
        return DistributorLocation({
            locationId: serverLocation.location_id,
            locationName: serverLocation.location_name,
            adminEmail: serverLocation.location_admin_email,
            hasPremiumPlan: serverLocation.has_premium_plan,
            hasGuestIncidentsLicense: serverLocation.has_guest_incidents_license,
            numUsers: serverLocation.num_users,
            invitationsTotal: serverLocation.invitations_total,
            invitationsAvailable: serverLocation.invitations_available,
            activeLicenseNames: serverLocation.active_license_names ?? [],
            // Only the search by id brings the detail
            adminEmails: serverLocation.admin_emails ?? [],
            devices: DistributorDeviceMapper.allServerToLocal(serverLocation.devices),
            licenses: LicenseMapper.allServerToLocal(serverLocation.licenses),
        });
    }
}
